class CourseObject {
    constructor(course) {
        this.id = course.course_id;
        this.par = course.Par;
        this.name = course.Name;
        this.code = course.code;
        this.holes = []; // par value for each hole
        this.scoring_level = course.scoring_level;
        for (let i = 0; i < 18; i++) {
            const key = "Hole" + (i+1);
            this.holes[i] = course[key];
        }
    }
}

export default CourseObject;